<template>
    <a-layout-header class="header">
        <slot name="head"></slot>
        <h1 class="LOGO">
            <a href="https://h5mota.com" target="_blank">H5MOTA</a>
        </h1>
        <div class="user" @click="handleLogin">
            <a-avatar :src="avatarURL" shape="square" />
            <span class="username">{{ username }}</span>
        </div>
        <a-modal title="登录" width="360px"
            v-model="loginDialogProxy" on-ok="confirm"
        >
            <a-form-model :model="form" :rules="rules" ref="loginForm">
                <a-form-model-item label="账号">
                    <a-input v-model="form.username"></a-input>
                </a-form-model-item>
                <a-form-model-item label="密码">
                    <a-input v-model="form.password" type="password"></a-input>
                </a-form-model-item>
            </a-form-model>
            <a class="el-link" href="/user/register.php" target="_blank">没有账号? 去注册</a>
            <template slot="footer">
                <a-button key="submit" type="primary" :loading="isLogining"
                    @click="confirm"
                >登录</a-button>
            </template>
        </a-modal>
    </a-layout-header>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    data() {
        return {
            valid: false,
            form: {
                username: "",
                password: ""
            },
            isLogining: false,
            rules: {
                username: [
                    { required: true, message: '请输入用户名' }
                ],
                password: [
                    { required: true, message: '请输入密码' }
                ],
            }
        }
    },
    computed: {
        ...mapState([
            "loginDialogVisible", "avatarURL", "username", "hasLogin", "userid"
        ]),
        loginDialogProxy: {
            get() {
                return this.loginDialogVisible;
            },
            set(value) {
                if (!value) {
                    this.closeLoginDialog();
                }
            }
        }
    },
    methods: {
        ...mapMutations([ "closeLoginDialog" ]),
        ...mapActions([ "openLoginDialog", "doLogin" ]),
        handleLogin() {
            if (this.hasLogin) {
                window.open("https://h5mota.com/user/indexPre.php");
            } else {
                this.openLoginDialog().then(() => {
                    if (this.hasLogin) {
                        window.location.reload();
                    }
                });
            }
        },
        confirm() {
            this.$refs.loginForm.validate(async (valid) => {
                if (valid) {
                    this.isLogining = true;
                    await this.doLogin(this.form);
                    this.isLogining = false;
                    this.$nextTick(() => {
                        if (this.hasLogin) {
                            this.closeLoginDialog();
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
header {
    display: flex;
    padding: 5px 15px;
    box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.3);
}
.LOGO {
    margin: 0;
    font-size: 28px;
    a {
        color: #22b6f2;
        text-decoration: none;
    }
}
.user {
    display: flex;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
    .username {
        color: #BBBBBB;
        margin-left: 5px;
    }
}
</style>